import { createFileRoute } from '@tanstack/react-router'
import { InvoiceListFeature } from '@/features/invoices/ui/InvoiceListFeature'
import { PermissionGuard } from '@/shared/components/PermissionGuard'
import { PERMISSIONS } from '@/shared/config/permissions'

export const Route = createFileRoute('/invoices/')({
  component: InvoicesRoute,
  staticData: { authorize: true },
})

function InvoicesRoute() {
  return (
    <PermissionGuard permission={PERMISSIONS.FinanceView}>
      <InvoiceListFeature />
    </PermissionGuard>
  )
}
